export default "__VITE_ASSET__em1dzyE2__"